export default defineNuxtRouteMiddleware(async (to, from) => {
    if (to.path !== '/' && to.path.endsWith('/')) {
        return navigateTo(to.path.slice(0, -1), { redirectCode: 301 });
    }
    // const supportedImageExtensions = ['.png', '.svg', '.jpg', '.jpeg', '.gif', '.webp', '.webmanifest']; // Voeg hier meer extensies toe als nodig
    // if (supportedImageExtensions.some(ext => to.path.toLowerCase().endsWith(ext))) {
    //     console.log('Image request detected, aborting navigation for: ', to.path);
    //     return abortNavigation(createError({ statusCode: 404, statusMessage: 'Not Found' }));
    // }

    const storesInitialized = useState('storesInitialized', () => false);
    if (!storesInitialized.value) return;

    const redirectStore = useRedirectStore();
    const redirectUrl = redirectStore.getRedirect(to.fullPath) || redirectStore.getRedirect(to.fullPath.substring(1));

    if (redirectUrl && redirectUrl !== to.fullPath) {
        return navigateTo(redirectUrl, { redirectCode: 301 });
    }
    else {
        console.log('no redirect found for: ', to.fullPath)
    }
});
